"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioboxGroup = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@chakra-ui/react");
const react_hook_form_1 = require("react-hook-form");
const chakra_lib_components_radiobox_1 = require("@eqg/chakra-lib.components.radiobox");
function RadioboxGroup(_a) {
    var { control, hGap, wGap, defaultValue, options, name, radioboxProps } = _a, rest = __rest(_a, ["control", "hGap", "wGap", "defaultValue", "options", "name", "radioboxProps"]);
    const { field, formState: { errors }, } = react_hook_form_1.useController({
        control,
        name: name,
        rules: rest.rules,
        defaultValue: defaultValue,
        shouldUnregister: rest.shouldUnregister,
    });
    const onClickRadio = react_1.useCallback((option) => {
        field.onChange(option.value);
    }, []);
    return (react_1.default.createElement(react_2.Flex, Object.assign({}, rest), options.map((option, index) => {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, { key: option.value },
            react_1.default.createElement(chakra_lib_components_radiobox_1.Radiobox, Object.assign({ error: (_a = errors[name.toString()]) === null || _a === void 0 ? void 0 : _a.message, isChecked: field.value === option.value, name: name, onBlur: field.onBlur, onClick: () => {
                    onClickRadio(option);
                } }, radioboxProps), option.label),
            index !== options.length - 1 && (react_1.default.createElement(react_2.Spacer, { w: wGap, minW: wGap, maxW: wGap, h: hGap, minH: hGap, maxH: hGap }))));
    })));
}
exports.RadioboxGroup = RadioboxGroup;
//# sourceMappingURL=RadioboxGroup.js.map